const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'actions/customProxy/quotations/create-quotation.action';
            binding.dataActions[actionPath] = require('partner/actions/customProxy/quotations/create-quotation.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/customProxy/quotations/get-quotation-by-id.action';
            binding.dataActions[actionPath] = require('partner/actions/customProxy/quotations/get-quotation-by-id.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/customProxy/quotations/get-quotation-history.action';
            binding.dataActions[actionPath] = require('partner/actions/customProxy/quotations/get-quotation-history.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/customProxy/restrictedProducts/get-restricted-products.action';
            binding.dataActions[actionPath] = require('partner/actions/customProxy/restrictedProducts/get-restricted-products.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/customProxy/sales-rep/get-sales-rep.action';
            binding.dataActions[actionPath] = require('partner/actions/customProxy/sales-rep/get-sales-rep.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/customProxy/sycor/process-sycor-customer.action';
            binding.dataActions[actionPath] = require('partner/actions/customProxy/sycor/process-sycor-customer.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-availabilities-for-selected-variant.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-availabilities-for-selected-variant.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-selected-variant.action';
            binding.dataActions[actionPath] = require('partner/actions/get-selected-variant.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/savesubmit-enabledisable.action';
            binding.dataActions[actionPath] = require('partner/actions/savesubmit-enabledisable.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };